import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextAreaInput from '../TextAreaInput';
import YesNoInput from '../YesNoInput';
import './YesNoDescriptionInput.scss';

const getValueField = (option, value, field) => {
  const optionValue = value && value.find((v) => v.id === option.id);
  return optionValue && optionValue[field];
};

class YesNoDescriptionInput extends Component {
  constructor(props) {
    super(props);
    this.onOptionValueChange = this.onOptionValueChange.bind(this);
  }

  onOptionValueChange(option, key, newVal) {
    const { value, onAnswerChange } = this.props;
    const currentOptionValue = value.find((v) => v.id === option.id);

    if (currentOptionValue) {
      // Replace the option value
      const others = value.filter((v) => v.id !== option.id);
      onAnswerChange([...others, { ...currentOptionValue, [key]: newVal }]);
      return;
    }

    // Append the option value
    onAnswerChange([
      ...value,
      {
        id: option.id, selected: null, desc: '', [key]: newVal,
      },
    ]);
  }

  render() {
    const {
      formKey, index, option, value, exampleText,
      selectedValue, descRequired, error, textAreaPrompt,
    } = this.props;
    const { id, name, description } = option;

    return (
      <div key={id} className={`mb-4 ${formKey}${id ? `-${id}` : ''}`}>
        <div className="option-container body-text-2 medium-weight">
          {error && error === 'radio_button' && (
          <div className="body-text-2 medium-weight with-error-text mb-2">
            <i className="fa fa-exclamation-triangle" />
            {' '}
            Required!
          </div>
          ) }
          <div className={`option-text mb-15 ${error && error === 'radio_button' && 'with-error-text'}`}>
            { index }
            .
            { name || description }
          </div>
          <YesNoInput
            className="yes-no-container mb-15 ms-3"
            id={`${formKey}${id || ''}`}
            value={selectedValue}
            onAnswerChange={(val) => this.onOptionValueChange(option, 'selected', val)}
          />
        </div>
        { selectedValue
          && (
          <div className="ms-2">
            {error && error === 'field' && (
            <div className="body-text-2 medium-weight with-error-text mb-2">
              <i className="fa fa-exclamation-triangle" />
              {' '}
              Required!
            </div>
            )}
            <TextAreaInput
              placeholder={descRequired ? 'Tell us more... (required)' : 'Tell us more...'}
              required={descRequired}
              error={error}
              value={getValueField(option, value, 'desc')}
              onAnswerChange={(val) => this.onOptionValueChange(option, 'desc', val)}
              exampleText={exampleText}
              textPromptClass={error && 'with-error-text'}
              textAreaPrompt={textAreaPrompt}
            />
          </div>
          )}
      </div>
    );
  }
}

YesNoDescriptionInput.propTypes = {
  formKey: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  option: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
  value: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    selected: PropTypes.string,
    desc: PropTypes.string,
  })),
  onAnswerChange: PropTypes.func.isRequired,
  exampleText: PropTypes.string,
  selectedValue: PropTypes.string.isRequired,
  descRequired: PropTypes.bool,
  error: PropTypes.string,
  textAreaPrompt: PropTypes.string,
};

YesNoDescriptionInput.defaultProps = {
  value: [],
  exampleText: null,
  descRequired: false,
  error: '',
  textAreaPrompt: 'Tell us more about that.',
};

export default YesNoDescriptionInput;
